export default __webpack_public_path__ + "static/media/err.499e5c52.png";